// @flow
import React from "react";
import MatchCentre from "../../components/MatchCentre";
import { withClassicPlayerModal } from "../../components";

export const ClassicMatchCentre = (props: Object) => {
	return <MatchCentre is_classic {...props} />;
};

export default withClassicPlayerModal(ClassicMatchCentre);